import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import GetDashboardStatisticsPeriodListRequest from '@/api/statistics/get-dashboard-statistics-period-list.request';
import GetStatisticsListRequest from '@/api/statistics/get-statistics-list.request';
import { Ref } from 'vue';

export class StatisticsApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
  ) {}

  public get getStatisticsListRequest(): GetStatisticsListRequest {
    return new GetStatisticsListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.GET,
    );
  }

  public get getDashboardStatisticsPeriodListRequest(): GetDashboardStatisticsPeriodListRequest {
    return new GetDashboardStatisticsPeriodListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.GET,
    );
  }
}
